<template>
  <page-container3>
    <div class="ant-pro-table">
      <div class="ant-pro-table-search" ref="searchEle" v-if="searchConfig.fields.length > 0">
        <search-render
          ref="config_render"
          :form="searchConfig"
          :model="searchConfig.model"
          :options="searchConfigOptions"
          :validateInfos="validateInfos"
          :resetFields="resetFields"
          @search="search"
        />
      </div>
      <a-card :body-style="{ padding: 0 }" ref="elRef">
        <div class="ant-pro-table-list-toolbar">
          <div class="ant-pro-table-list-toolbar-container">
            <div class="ant-pro-table-list-toolbar-left">
              <!--              <div class="ant-pro-table-list-toolbar-title">{{ titleList.title }}</div>-->
              <component v-if="headerComponent" :is="headerComponent" v-bind="state"></component>
            </div>
            <div class="ant-pro-table-list-toolbar-right">
              <a-space align="center">
                <a-button v-if="titleList.is_create" type="primary" size="small" @click="handleAdd">
                  <plus-outlined />
                  {{ titleList.addModalTitle }}
                </a-button>
                <a-button
                  v-for="btn in head_btn_list"
                  size="small"
                  :key="btn.name"
                  @click="
                    btn.cb(
                      searchConfig.model,
                      state.dataSource,
                      selectedRowKeys,
                      searchConfigOptions,
                    )
                  "
                  :type="btn.clazz"
                >
                  <plus-outlined v-if="btn.icon === 'plus-outlined'" />
                  {{ btn.name }}
                </a-button>
                <div class="ant-pro-table-list-toolbar-setting-item">
                  <a-tooltip title="导出Excel">
                    <export-excel-modal
                      :column-list="dynamicColumnItems"
                      :datasource="state.dataSource"
                      :filename="titleList.title"
                      :columns="dynamicColumns"
                      :pageSize="state.pageSize"
                      :current="state.current"
                    />
                  </a-tooltip>
                </div>
              </a-space>
            </div>
          </div>
        </div>
        <s-table
          :bordered="true"
          :height="tableHeight.y"
          :size="state.tableSize"
          v-model:columns="dynamicColumns"
          :data-source="state.dataSource"
          :indentSize="15"
          :autoRowHeight="true"
          :wrapText="true"
          :rowHeight="undefined"
          :rowKey="rowKey ? rowKey : 'id'"
          :loading="state.loading"
          :customRow="customRow"
          :customHeaderCell="customHeaderCell"
          :customCell="customCell"
          stripe
          sticky
          summary-fixed
          :pagination="
            is_pagination
              ? {
                  current: state.current,
                  pageSize: state.pageSize,
                  total: state.total,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  pageSizeOptions: pageSizeOptions,
                }
              : false
          "
          @change="handleTableChange"
          @resizeColumn="resizeColumn"
          :rowSelection="rowSelection"
          :expandedRowRender="expandedRowRender"
          v-model:selectedRowKeys="selectedRowKeys"
        >
          <template #bodyCell="{ column, index, text, record }">
            <template v-if="column.dataIndex == 'index'">
              {{ index + 1 + state.pageSize * (state.current - 1) }}
            </template>
            <component
              v-else-if="column.cellComponent"
              :is="'Cell_' + column.cellComponent"
              v-bind="{
                column: column,
                index: index,
                text: text,
                record: record,
                pageSize: state.pageSize,
                current: state.current,
                titleList: titleList,
                column_normal_btn_list: column_normal_btn_list,
                column_dropdown_btn_dict: column_dropdown_btn_dict,
                handleOpenEdit: handleOpenEdit,
                handleDelete: handleDelete,
                handleRecover: handleRecover,
              }"
            ></component>
            <template v-else>
              <span :style="column.color ? column.color(record, text) : null">
                {{ column.content ? column.content(record, text) : text }}
              </span>
            </template>
          </template>

          <template #expandedRowRender="{ record }" v-if="expandedRowRenderComponent">
            <component :is="expandedRowRenderComponent(record)" v-bind="record"></component>
          </template>
          <template #summary v-if="summaryColumnsShow">
            <s-table-summary-row>
              <s-table-summary-cell
                :columnKey="item.columnKey"
                v-for="item in summaryColumns"
                :key="item.index"
              >
                <div v-if="item.index == 0">合计</div>
                <div v-else-if="!item.summary">&nbsp;</div>
                <template #default="{ total }" v-if="item.summary">
                  <span :style="item.total_color ? item.total_color(total) : 'float: right;'">
                    {{
                      item.cellComponent == 'money'
                        ? $numeral.money(total)
                        : item.total_content
                        ? item.total_content(total)
                        : toFixed6(total)
                    }}
                  </span>
                </template>
              </s-table-summary-cell>
            </s-table-summary-row>
          </template>
        </s-table>
      </a-card>
    </div>
    <form-modal
      v-bind="editModalAdd"
      v-if="editModalAdd.visible"
      :loading="confirmLoading"
      @cancel="
        () => {
          editModalAdd.visible = false;
        }
      "
      @ok="handlerOk"
    />
    <form-modal
      v-bind="editModalUpdate"
      v-if="editModalUpdate.visible"
      :loading="confirmLoading"
      @cancel="
        () => {
          editModalUpdate.visible = false;
        }
      "
      @ok="handlerOk"
    />
  </page-container3>
</template>

<script lang="ts">
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  watch,
  computed,
  createVNode,
  onActivated,
  onDeactivated,
} from 'vue';
import {
  PlusOutlined,
  ExclamationCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  RedoOutlined,
} from '@ant-design/icons-vue';
import { TableColumn } from '@/typing';
import { useFetchData } from '@/utils/hooks/useFetchData';
import { useFullscreen } from '@/utils/hooks/useFullscreen';
import { useTableDynamicColumns } from '@/utils/hooks/useTableColumn';
import FormModal from '@/components/form-modal/form-modal.vue';
import { useStore } from 'vuex';
import { message, Modal } from 'ant-design-vue';
import { useForm } from 'ant-design-vue/es/form';
import SearchRender from '@/components/FormRender/SearchRender.vue';
import getPageConfig from '@/components/page-model/index';
import { useRoute } from 'vue-router';
import { Record } from '@/components/page-model/typing';
import { isNumber } from 'lodash';
import { debounce } from 'lodash-es';

export default defineComponent({
  name: 'PageModel',
  props: {
    modalType: {
      type: String,
    },
    activeKey: {
      type: String,
    },
  },
  setup(props: any) {
    const confirmLoading = ref<boolean>(false);
    const tableRef = ref<any>();
    const store = useStore();
    const current_org = store.getters['user/current_org'];
    // const custome_data_user = store.getters['user/custome_data_user'];
    const checkAll = ref<boolean>(false);
    const checkAction = ref<boolean>(false);
    let formModalUpdate = false; // 判断显示创建、修改

    const searchEle: any = ref();
    const tableHeight = reactive({ y: window.innerHeight - 225 });
    const onresize: any = debounce(() => {
      if (searchEle.value) {
        tableHeight.y = window.innerHeight - searchEle.value.offsetHeight - 225;
      } else {
        tableHeight.y = window.innerHeight - 225;
      }
    }, 200);
    onMounted(() => {
      window.onresize = onresize;
      onresize();
    });
    const route = useRoute();
    const path_arr = route.path.split('/');
    const field = {
      modalType: path_arr[path_arr.length - 1],
      column_flag: 'column_' + path_arr[path_arr.length - 1],
    };
    if (props.modalType) {
      field.modalType = props.modalType as string;
      field.column_flag = 'column_' + props.modalType;
    }

    const summaryColumns = computed(() => {
      return dynamicColumns.value
        .filter((item: any) => {
          if (item.checked === true) {
            return true;
          } else if (item.checked === undefined) {
            return true;
          }
          return false;
        })
        .map((item: any, index: number) => {
          const obj = {
            index: index,
            columnKey: item.dataIndex,
            summary: item.summary,
            total_color: item.total_color,
            total_content: item.total_content,
            cellComponent: item.cellComponent,
          };
          return obj;
        });
    });
    const summaryColumnsShow = computed(() => {
      console.log('dynamicColumns.value', dynamicColumns.value);
      console.log('dynamicColumnItems.value', dynamicColumnItems.value);
      return dynamicColumns.value.filter(item => item.summary).length > 0;
    });

    watch(
      () => props.activeKey,
      () => {
        if (props.activeKey == props.modalType) {
          reload();
        }
      },
    );

    // 时间区间格式转化 数组-->字符串
    const getRangePicker = (api_fields: Record, record: Record) => {
      const obj: any = {};
      for (const key in api_fields) {
        if (record[api_fields[key] as string]) {
          obj[key] = record[api_fields[key] as string].join(',');
        }
      }
      return obj;
    };

    const {
      searchConfig,
      searchConfigOptions,
      formModalConfig,
      formModalConfigOptions,
      updateFormModalConfig,
      updateFormModalConfigOptions,
      queryData,
      processData,
      processColumn,
      addData,
      updateData,
      removeData,
      recoverData,
      baseColumns,
      column_list_change,
      titleList,
      api_fields,
      btn_list,
      head_btn_list,
      event_obj,
      init_request,
      selectedRowKeys,
      rowSelection,
      expandedRowRender,
      expandedRowRenderComponent,
      headerComponent,
      rowKey,
      pageSize,
      customCell,
      customRow,
      customHeaderCell,
      is_pagination,
      pageSizeOptions,
    } = getPageConfig(field.modalType);

    const column_normal_btn_list: any = computed(() => {
      return btn_list?.filter((item: any) => item.type == undefined || item.type == 'btn');
    });
    const column_dropdown_btn_dict: any = computed(() => {
      const l = btn_list?.filter((item: any) => item.type == 'dropdown');
      if (l && l.length > 0) {
        return { dropdown_btn: l[0], btn_list: l.slice(1) };
      } else {
        return null;
      }
    });

    if (searchConfig.fields) {
      for (let i = 0; i < searchConfig.fields.length; i++) {
        // 预先填充 placeholder
        let filed_dict = searchConfig.fields[i];
        if (!filed_dict.placeholder) {
          let pre_str = filed_dict.type == 'input' ? '请填写' : '请选择';
          filed_dict.placeholder = pre_str + filed_dict.label;
        }

        // 预先填充 校验message
        let search_rule_dict = searchConfig.rules[filed_dict.name];
        if (search_rule_dict) {
          if (!search_rule_dict.message) {
            search_rule_dict.message = filed_dict.placeholder;
          }
        }
      }
    }

    if (formModalConfig.fields) {
      for (let i = 0; i < formModalConfig.fields.length; i++) {
        let filed_dict = formModalConfig.fields[i];
        if (!filed_dict.placeholder) {
          let pre_str = filed_dict.type == 'input' ? '请填写' : '请选择';
          filed_dict.placeholder = pre_str + filed_dict.label;
        }
      }
    }

    const event_obj_refresh_search = (query_data: any) => {
      Object.assign(searchConfig.model, query_data);
      search();
    };
    const event_obj_reload = () => {
      reload();
    };

    const event_obj_local_refresh = () => {
      state.dataSource = [].concat(state.dataSource as any);
    };

    event_obj?.on('refresh_search', event_obj_refresh_search);
    event_obj?.on('refresh', event_obj_reload);
    event_obj?.on('reset_and_reload', event_obj_reload);
    event_obj?.on('local_refresh', event_obj_local_refresh);
    onActivated(() => {
      // reload();
      event_obj?.off('refresh_search', event_obj_refresh_search);
      event_obj?.off('refresh', event_obj_reload);
      event_obj?.off('reset_and_reload', event_obj_reload);
      event_obj?.off('local_refresh', event_obj_local_refresh);
      // 先解监听，再监听，防止重复
      event_obj?.on('refresh_search', event_obj_refresh_search);
      event_obj?.on('refresh', event_obj_reload);
      event_obj?.on('reset_and_reload', event_obj_reload);
      event_obj?.on('local_refresh', event_obj_local_refresh);
    });
    onDeactivated(() => {
      event_obj?.off('refresh_search', event_obj_refresh_search);
      event_obj?.off('refresh', event_obj_reload);
      event_obj?.off('reset_and_reload', event_obj_reload);
      event_obj?.off('local_refresh', event_obj_local_refresh);
    });
    baseColumns.map((item: any) => {
      item.resizable = !(item.resizable === false);
    });

    // let tmpBaseColumns = null;
    // if (custome_data_user && custome_data_user[field.column_flag]) {
    //   baseColumns.map((item: any, index: number) => {
    //     if (custome_data_user[field.column_flag][item.dataIndex]) {
    //       item.sort_num = index;
    //       item.sort_num = custome_data_user[field.column_flag][item.dataIndex]['index'];
    //       item.checked = custome_data_user[field.column_flag][item.dataIndex]['checked'];
    //     }
    //   });
    //   tmpBaseColumns = baseColumns.sort((a: any, b: any) => a.sort_num - b.sort_num);
    // }
    const {
      state: columnState,
      dynamicColumns,
      dynamicColumnItems,
      handleColumnAllClick,
      handleColumnChange,
      reset,
      move,
      configState,
      update_column_org_config,
      update_column_data,
      resizeColumn,
      switch_column_config,
      columnAction,
      column_change,
      replace_column,
    } = useTableDynamicColumns(
      baseColumns as TableColumn[],
      {
        checkAll: false,
        needRowIndex: false,
      },
      store,
      field.column_flag,
      column_list_change,
    );

    // watch(
    //   () => dynamicColumnItems,
    //   () => {
    //     const column_data_json: any = {};
    //     dynamicColumnItems.value.map((item, index) => {
    //       column_data_json[item.key] = { key: item.key, index: index, checked: item.checked };
    //     });
    //
    //     set_custom_data_by_flag({
    //       org_id: current_org?.id,
    //       flag: field.column_flag,
    //       data: JSON.stringify(column_data_json),
    //     }).then(function() {
    //       store.dispatch(`user/${GET_CUSTOME_DATA_USER}`, { org_id: Number(current_org?.id) });
    //     });
    //   },
    //   { deep: true },
    // );
    const [elRef, screenState, { setFull, exitFull }] = useFullscreen();
    const { resetFields, validateInfos } = useForm(searchConfig.model, searchConfig.rules);
    Object.keys(route.query).map((key: string) => {
      if (searchConfig.fields.find((item: any) => item.name == key)) {
        searchConfig.model[key] = route.query[key];
      }
    });
    const {
      stripe,
      reload,
      setPageInfo,
      context: state,
    } = useFetchData(
      queryData,
      {
        current: 1,
        pageSize: searchConfig.model.pageSize
          ? searchConfig.model.pageSize
          : pageSize
          ? pageSize
          : 10,
        tableSize: 'small', // 'default' | 'middle' | 'small'
        stripe: true,
        init_request: !(init_request === false),
        requestParams: {
          ...searchConfig.model,
          ...getRangePicker(api_fields.rangepicker, searchConfig.model),
        },
      },
      undefined,
      processData,
      processColumn,
      replace_column,
    );

    let sortFieldList: Array<string> = [];
    const handleTableChange = (pagination: any, filters: any, sorter: any) => {
      let filter_map: any = {};
      let sort_fields: any = [];
      for (let key in filters) {
        filter_map[key] = filters[key].map((x: any) => x.toString()).join(',');
      }
      if (sorter instanceof Array) {
        sortFieldList = sortFieldList.filter((field: string) => {
          return sorter.find((item: any) => field == item.column.dataIndex) != undefined;
        });
        sorter.map((item: any) => {
          if (!sortFieldList.includes(item.column.dataIndex)) {
            sortFieldList.push(item.column.dataIndex);
          }
        });
        sort_fields = sortFieldList.map((field: string) => {
          if (sorter.find((item: any) => field == item.column.dataIndex).order == 'descend') {
            return `-${field}`;
          } else {
            return field;
          }
        });
      } else if (sorter != undefined && sorter.column != undefined) {
        sortFieldList.length = 0;
        sortFieldList.push(sorter.column.dataIndex);

        if (sorter.order == 'ascend') {
          sort_fields.push(sorter.column.dataIndex);
        }
        if (sorter.order == 'descend') {
          sort_fields.push('-' + sorter.column.dataIndex);
        }
      } else {
        sortFieldList.length = 0;
      }

      for (let key in filters) {
        filter_map[key] = filters[key].map((x: any) => x.toString()).join(',');
      }
      setPageInfo({
        current: pagination?.current ? pagination?.current : 1,
        pageSize: pagination?.pageSize ? pagination?.pageSize : 50,
        ...searchConfig.model,
        ...filter_map,
        sort_fields: sort_fields,
      });
      reload();
    };

    const clearFilterAndOrder = (column: any) => {
      if (column.filteredValue != undefined) {
        column.filteredValue.length = 0;
      }
      if (column.sortOrder != undefined) {
        column.sortOrder = false;
      }

      if (column.children != undefined) {
        column.children.forEach((item: any) => clearFilterAndOrder(item));
      }
    };

    const search = () => {
      sortFieldList.length = 0;
      dynamicColumns.value.forEach((column: any) => clearFilterAndOrder(column));
      setPageInfo({
        current: 1,
        ...searchConfig.model,
        ...getRangePicker(api_fields.rangepicker, searchConfig.model),
      });
      reload();
      onresize();
    };

    // edit
    const editModalAdd = reactive({
      visible: false,
      title: '',
      form: formModalConfig,
      options: formModalConfigOptions,
    });
    const editModalUpdate = reactive({
      visible: false,
      title: '',
      form: updateFormModalConfig,
      options: updateFormModalConfigOptions,
    });
    let currentRecord = reactive({ name: '' });
    const handleOpenEdit = (record: any) => {
      formModalUpdate = true;
      editModalUpdate.visible = true;
      editModalUpdate.title = titleList.updateTitle;
      editModalUpdate.form.model = {
        ...updateFormModalConfig.model,
        ...record,
        ...getObjList(api_fields.update, record),
      };

      currentRecord = record;
    };
    const handleAdd = () => {
      formModalUpdate = false;
      editModalAdd.visible = true;

      editModalAdd.form.model = { ...formModalConfig.model };
      editModalAdd.title = titleList.addModalTitle;
    };

    const handleDelete = (record: any) => {
      Modal.confirm({
        title: '是否禁用此项记录?',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          return new Promise(resolve => {
            removeData({
              org_id: current_org.id,
              ...getObjList(api_fields.delete, record),
            }).then((res: any) => {
              message.success('禁用成功');
              Object.assign(record, res);
              event_obj_local_refresh();
              resolve(null);
            });
          }).catch(() => console.log('Oops errors!'));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onCancel() {},
      });
      // removeData({
      //   org_id: current_org.id,
      //   ...getObjList(api_fields.delete, record),
      // }).then((res: any) => {
      //   message.success('删除成功');
      //   Object.assign(record, res);
      // });
    };
    const handleRecover = (record: any) => {
      recoverData({
        org_id: current_org.id,
        ...getObjList(api_fields.recover, record),
      }).then((res: any) => {
        message.success('恢复成功');
        Object.assign(record, res);
        event_obj_local_refresh();
      });
    };

    const handlerOk = (data: any) => {
      confirmLoading.value = true;
      if (!formModalUpdate) {
        addData({ ...data })
          .then(() => {
            message.success('创建成功');
            reload();
            editModalAdd.visible = false;
          })
          .finally(() => {
            confirmLoading.value = false;
            console.error('finally ');
          });
      } else {
        updateData({
          ...data,
          ...getObjList(api_fields.updateData, data),
          ...getObjList(api_fields.updateData, editModalUpdate.form.model),
        })
          .then((res: any) => {
            Object.assign(currentRecord, res);
            event_obj_local_refresh();
            message.success('修改成功');
            editModalUpdate.visible = false;
            formModalUpdate = false;
          })
          .finally(() => {
            confirmLoading.value = false;
            console.error('finally ');
          });
      }
    };

    // 字段对应错误————>转化正确
    const getObjList = (api_fields: Record, record: Record) => {
      const obj: any = {};
      for (const key in api_fields) {
        if (record[api_fields[key] as string]) {
          obj[key] = record[api_fields[key] as string];
        }
      }
      return obj;
    };

    // 接口返回时间，格式优化
    const getDateTime = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(0, 16);
      } else if (time) {
        time = time.substring(0, 16);
      }
      return time;
    };
    const getDate = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(0, 10);
      } else if (time) {
        time = time.substring(0, 10);
      }
      return time;
    };
    const getDateMonth = (time: any) => {
      if (time) {
        time = time.substring(0, 4) + '年' + time.substring(5, 7) + '月';
      }
      return time;
    };
    const getTime = (time: any) => {
      if (time) {
        time = time.substring(0, 5);
      }
      return time;
    };

    // // 列’默认‘ ’全部‘ 展示的切换
    // let old_list: any[] = []; // 定义old_list记录默认数据
    // const column_change = () => {
    //   if (checkAll.value) {
    //     dynamicColumnItems.value.forEach(org => {
    //       old_list.push(org);
    //       let b = {
    //         ...org,
    //         checked: true,
    //       };
    //       let a: any = {};
    //       a.target = b;
    //       handleColumnChange(a, b);
    //     });
    //   } else {
    //     old_list.forEach(org => {
    //       let a: any = {};
    //       a.target = org;
    //       handleColumnChange(a, org);
    //     });
    //   }
    // };

    const toFixed0 = (num: any) => {
      if (isNumber(num)) {
        if (Number(num.toFixed(0)) == 0) {
          return 0;
        } else {
          return num.toFixed(0);
        }
      } else {
        return '';
      }
    };
    const toFixed6 = (num: any) => {
      if (isNumber(num)) {
        if (Number(num.toFixed(6)) == 0) {
          return 0;
        } else {
          return num.toFixed(6);
        }
      } else {
        return '';
      }
    };
    const toFixed2 = (num: any) => {
      if (isNumber(num)) {
        if (Number(num.toFixed(2)) == 0) {
          return 0;
        } else {
          return num.toFixed(2);
        }
      } else {
        return '';
      }
    };

    return {
      toFixed0,
      toFixed6,
      toFixed2,
      tableRef,
      getDateTime,
      getTime,
      getDate,
      getDateMonth,
      getRangePicker,
      checkAll,
      checkAction,
      titleList,
      tableHeight,
      state,
      stripe,
      columnState,
      dynamicColumns,
      dynamicColumnItems,
      summaryColumns,

      confirmLoading,
      handleAdd,
      handlerOk,
      currentRecord,
      resetFields,
      validateInfos,
      // fullscreen
      elRef,
      screenState,
      setFull,
      exitFull,

      handleTableChange,
      search,

      handleColumnChange,
      handleColumnAllClick,
      reset,
      move,
      current_org,
      message,
      // edit
      editModalAdd,
      editModalUpdate,
      handleOpenEdit,
      handleDelete,
      handleRecover,
      reload,
      getPageConfig,
      searchConfig,
      searchConfigOptions,
      formModalConfig,
      formModalConfigOptions,
      updateFormModalConfig,
      updateFormModalConfigOptions,
      getObjList,
      field,
      api_fields,
      column_normal_btn_list,
      column_dropdown_btn_dict,
      head_btn_list,
      configState,
      update_column_org_config,
      update_column_data,
      resizeColumn,
      switch_column_config,
      columnAction,
      column_change,
      replace_column,
      summaryColumnsShow,
      processData,
      processColumn,
      column_list_change,
      init_request,
      selectedRowKeys,
      rowSelection,
      expandedRowRender,
      expandedRowRenderComponent,
      headerComponent,
      rowKey,
      pageSize,
      searchEle,
      pageSizeOptions: pageSizeOptions
        ? pageSizeOptions
        : [
            '5',
            '10',
            '15',
            '20',
            '30',
            '50',
            '100',
            '200',
            '1000',
            '3000',
            '10000',
            '30000',
            '50000',
          ],
      is_pagination: is_pagination === false ? false : true,
      customCell: customCell ? customCell : () => {},
      customRow: customRow ? customRow : () => {},
      customHeaderCell: customHeaderCell ? customHeaderCell : () => {},
    };
  },
  components: {
    // DragIcon,
    PlusOutlined,
    RedoOutlined,
    EditOutlined,
    DeleteOutlined,
    // ReloadOutlined,
    // ColumnHeightOutlined,
    // SettingOutlined,
    // FullscreenOutlined,
    // FullscreenExitOutlined,
    // Draggable,
    // DragContainer,
    FormModal,
    SearchRender,
  },
});
</script>
